import { retrieveErrorFromApi } from '../../../helper'
import { setAppErrors } from '../../action/system'
import getPickupOrders from '../../axios/orderview/pickup'
import updateOrderPickupStatus from '../../axios/order/pickupStatus/put'
import { addPickupMonitorAwaitingPickupOrder, addPickupMonitorProcessingPickupOrder, removePickupMonitorAwaitingPickupOrder, removePickupMonitorProcessingPickupOrder, setPickupMonitorAwaitingPickupOrders, setPickupMonitorIsOrdersStatusUpdating, setPickupMonitorProcessingPickupOrders } from '../../action/pickupMonitor'
import { selectAwaitingPickupOrders, selectProcessingPickupOrders } from '../../selector/pickupMonitor'

export const getAwaitingPickupOrdersThunk = (page = 0, size = 50) => async (dispatch) => {
	try {
		const res = await getPickupOrders(page, size, 'AWAITING_PICKUP', 'awaitingPickupDate')
		dispatch(setPickupMonitorAwaitingPickupOrders(res.data))
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const getProcessingPickupOrdersThunk = (page = 0, size = 50) => async (dispatch) => {
	try {
		const res = await getPickupOrders(page, size, 'PROCESSING_PICKUP', 'processingPickupDate')
		dispatch(setPickupMonitorProcessingPickupOrders(res.data))
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const updateOrderPickupStatusThunk = (orderId, statusToUpdate) => async (dispatch, getState) => {
	dispatch(setPickupMonitorIsOrdersStatusUpdating(true))
	try {
		const res = await updateOrderPickupStatus(orderId, statusToUpdate)
		const updatedOrder = res.data
		const awaitingPickupOrders = selectAwaitingPickupOrders(getState())
		const processingPickupOrders = selectProcessingPickupOrders(getState())
		const existAwaitingOrder = awaitingPickupOrders.find(order => order.orderId === orderId)
		const existProcessingOrder = processingPickupOrders.find(order => order.orderId === orderId)
		await new Promise(resolve => setTimeout(resolve, 500))

		if (existAwaitingOrder) {
			dispatch(removePickupMonitorAwaitingPickupOrder(updatedOrder))
		} else if (existProcessingOrder) {
			dispatch(removePickupMonitorProcessingPickupOrder(updatedOrder))
		}

		if (statusToUpdate === 'PROCESSING_PICKUP') {
			dispatch(addPickupMonitorProcessingPickupOrder(updatedOrder))
		} else if (statusToUpdate === 'AWAITING_PICKUP') {
			dispatch(addPickupMonitorAwaitingPickupOrder(updatedOrder))
		}
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	} finally {
		dispatch(setPickupMonitorIsOrdersStatusUpdating(false))
	}
}
